import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import ListItemText from '@material-ui/core/ListItemText';
import MaterialListItem from '@material-ui/core/ListItem';

const ListItem = (props) => {
    // noinspection JSValidateTypes
    return (
        <MaterialListItem button={true} component={NavLink} to={props.to} activeClassName='Mui-selected'
                          onClick={props.onClick} {...props}
        >
            <ListItemText>{props.title}</ListItemText>
            {props.children}
        </MaterialListItem>
    );
};

ListItem.propTypes = {
    title: PropTypes.string.isRequired,
    activeClassName: PropTypes.string,
    to: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

ListItem.defaultProps = {
    activeClassName: 'Mui-selected',
};

export default ListItem;
